<div class="edit-exhibitor-multimedia">
  <h2>{{ 'EDIT_EXHIBITOR_MULTIMEDIA.TITLE' | translate }}</h2>

  <div class="section-container">
    <div class="edit-exhibitor-multimedia__header-container">
      <h3>{{ 'EDIT_EXHIBITOR_MULTIMEDIA.IMAGES_SUBTITLE' | translate }}</h3>
    </div>
    <p>{{ "EDIT_EXHIBITOR_MULTIMEDIA.IMAGES" | translate }}</p>
    <p>{{ "EDIT_EXHIBITOR_MULTIMEDIA.CATALOGUE_PLAN" | translate }} ({{ exhibitorData['images'].length }}/ {{ exhibitorData['imageExhibitorLimit'] }}) .{{ "EDIT_EXHIBITOR_MULTIMEDIA.IMAGES_RECOMENDED_SIZE" | translate }}</p>
    <div class="edit-exhibitor-multimedia__images">
      <div class="edit-exhibitor-multimedia__image" *ngFor="let image of exhibitorData['images']">
        <img [src]="image.url" class="image" name="{{ 'image-' + image.id }}" />
        <img class="pointer remove-item-img" width="25" height="25"  src="assets/img/close_white.svg" (click)="removeImage(image)" >
      </div>
    </div>
    <div class="image-wrap pointer addFile">
      <label>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.75 8.25H8.25V10.5H6V12H8.25V14.25H9.75V12H12V10.5H9.75V8.25ZM10.5 1.5H4.5C3.675 1.5 3 2.175 3 3V15C3 15.825 3.6675 16.5 4.4925 16.5H13.5C14.325 16.5 15 15.825 15 15V6L10.5 1.5ZM13.5 15H4.5V3H9.75V6.75H13.5V15Z" fill="black"/>
        </svg>
        <span>{{ 'EDIT_EXHIBITOR_MULTIMEDIA.ADD_IMAGE' | translate }}</span>
        <input type="file" id="image-file" accept="image/*" hidden (change)="imageFileChange($event)">
      </label>
    </div>

  </div>

  <div class="section-container">
    <div class="edit-exhibitor-multimedia__header-container">
      <h3>{{ 'EDIT_EXHIBITOR_MULTIMEDIA.FILES_SUBTITLE' | translate }}</h3>
    </div>
    <p>{{ "EDIT_EXHIBITOR_MULTIMEDIA.CATALOGUE_PLAN" | translate }} ({{ exhibitorData['files'].length }}/ {{ this.maxFileCount }}) .{{ "EDIT_EXHIBITOR_MULTIMEDIA.FILES_RECOMENDED_SIZE" | translate }}</p>
    <div class="edit-exhibitor-multimedia__files">
      <div class="edit-exhibitor-multimedia__file" *ngFor="let file of exhibitorData['files']">
        <a [href]="file.url" target="_blank" name="{{ 'file-' + file.id }}" >{{ file.url }}</a>
        <img class="pointer remove-item-file" width="25" height="25"  src="assets/img/close_black.svg" (click)="removeFile(file)" >
      </div>
    </div>
    <div class="image-wrap pointer addFile">
      <label>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.75 8.25H8.25V10.5H6V12H8.25V14.25H9.75V12H12V10.5H9.75V8.25ZM10.5 1.5H4.5C3.675 1.5 3 2.175 3 3V15C3 15.825 3.6675 16.5 4.4925 16.5H13.5C14.325 16.5 15 15.825 15 15V6L10.5 1.5ZM13.5 15H4.5V3H9.75V6.75H13.5V15Z" fill="black"/>
        </svg>
        <span>{{ 'EDIT_EXHIBITOR_MULTIMEDIA.ADD_FILE' | translate }}</span>
        <input type="file" id="doc-file" accept="*/*" hidden (change)="fileChange($event)">
      </label>
    </div>
  </div>

  <div class="section-container">
    <h3>{{ 'EDIT_EXHIBITOR_MULTIMEDIA.VIDEO_SUBTITLE' | translate }}</h3>
    <div class="edit-exhibitor-multimedia__video">
      <p>{{ "EDIT_EXHIBITOR_MULTIMEDIA.VIDEO" | translate }}</p>
    </div>
    <form class="form-group">
      <input type="text" name="video" [(ngModel)]="exhibitorData['exhibitor']['videoUrl']" class="custom-form-control form-control">
    </form>
    <app-detail-video [projection]="exhibitorData['exhibitor']"></app-detail-video>
  </div>
</div>
